import React from "react";
import "./style.css"

function Footer() {
    return (
        <>
            <footer className="footer d-flex flex-column bg-dark">
                <p className="footer-copyright text-center small py-1">Copyright © Alisha Saleh <br />
                    <a id="footer-ref" href='https://www.freepik.com/vectors/background'>Background vector created by
                visnezh</a>
                </p>
            </footer>
        </>
    )
}

export default Footer;